import "./Pages.css";
const About=()=>{
     return (
    <div className="about">

      {/* Hero Section */}
      <section className="about-hero">
        <h1>About Us</h1>

        <p>
          We are a technology company dedicated to helping businesses
          streamline their operations through innovative software solutions.
          Our mission is to simplify e-commerce, automate order management,
          and improve customer communication using modern digital technologies.
        </p>
      </section>

      {/* Company Section */}
      <section className="about-content">

        <div className="about-card">
          <h2>Who We Are</h2>

          <p>
            We specialize in developing end-to-end E-commerce Solutions,
            Order Management Systems (OMS), and customer communication
            platforms. Our solutions are designed to help businesses
            efficiently manage sales, inventory, shipping, and customer
            engagement from a single platform.
          </p>
        </div>

        <div className="about-card">
          <h2>Our Mission</h2>

          <p>
            Our mission is to empower businesses with reliable, scalable,
            and secure technology that automates operations, enhances
            customer experience, and drives sustainable growth.
          </p>
        </div>

        <div className="about-card">
          <h2>Our Vision</h2>

          <p>
            To become a trusted technology partner for businesses by
            delivering innovative digital solutions that improve efficiency,
            productivity, and customer satisfaction.
          </p>
        </div>

      </section>

      {/* What We Offer */}
      <section className="offer-section">

        <h2>What We Offer</h2>

        <div className="offer-container">

          <div className="offer-card">
            <h3>🛒 E-commerce Solutions</h3>
            <p>
              Complete online store development with secure, scalable,
              and customized solutions.
            </p>
          </div>

          <div className="offer-card">
            <h3>📦 Order Management System</h3>
            <p>
              Manage orders, inventory, shipping, returns, and customer
              information through a centralized platform.
            </p>
          </div>

          <div className="offer-card">
            <h3>📩 SMS Services</h3>
            <p>
              Instant SMS notifications for OTPs, order updates,
              delivery alerts, and promotional campaigns.
            </p>
          </div>

          <div className="offer-card">
            <h3>📧 Email Services</h3>
            <p>
              Automated emails for invoices, order confirmations,
              newsletters, and marketing campaigns.
            </p>
          </div>

          <div className="offer-card">
            <h3>💬 WhatsApp Business API</h3>
            <p>
              Send automated WhatsApp messages for order tracking,
              customer support, promotions, and notifications.
            </p>
          </div>

          <div className="offer-card">
            <h3>⚙ Business Automation</h3>
            <p>
              Automate business workflows and integrate multiple
              systems to improve operational efficiency.
            </p>
          </div>

        </div>

      </section>

    </div>
  );
};
export default About;